import React, { useEffect, useState } from "react";
import { useMediaQuery } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import OfferCarousel from "./Components/OfferCarousel";
import Ads from "./Components/Ads";
import Faq from "./Components/Faq";
import AppSuggestion from "./Components/AppSuggestion";
import Event from "./Components/Event";
import FeaturedCategories from "./Components/FeaturedCategories";
import PopularProducts from "./Components/PopularProducts";
import Combo from "./Components/Combo";
import TrendingProducts from "./Components/TrendingProducts";
import Howitworks from "./Components/Howitworks";
import CategoryOffer from "./Components/CategoryOffer";
import "./Landing.css";
import { useGetAPIWithoutTokenQuery } from "../Api/api";
import { CATEGORYOFFER, READ_ALL_EVENTS } from "../Api/apiConstant";
import { crOffer } from "../Features/Offer/offerSlice";
import { storeEventName } from "../Utils/sessionutility";
import { useThemeColors } from "../Context/Theme";
import { getToken, getUserId } from "../LoginModule/LoginUtility";
import { toast, ToastContainer } from "react-toastify";

const Landing = () => {
  const { primaryColor, backgroundColor,   fontFamily,
    fontWeight,
    fontSize,
    fontFamilyHeading,
    fontWeightHeading,
    fontSizeHeading,
    textColor,
   } = useThemeColors();
  const isMobile = useMediaQuery("(max-width: 600px)");
  const isTablet = useMediaQuery("(max-width: 800px)");

  const [eventName, setEventName] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const cartId = sessionStorage.getItem("cart_id");
  const userId = getUserId()
  const token = getToken();
  const eventId = sessionStorage.getItem("event_id");
  const [isAtAllEvents, setIsAtAllEvents] = useState(false);

  const {
    data: offerImages,
    isLoading: offerLoading,
    isError: offerError,
  } = useGetAPIWithoutTokenQuery(
    `${CATEGORYOFFER}event_id=${eventId}&type=category`, { refetchOnMountOrArgChange: true, skip: !eventId }
  );

  const { data, isSuccess, isError, error } =
    useGetAPIWithoutTokenQuery(READ_ALL_EVENTS);
  const filteredEvent =
    eventId &&
    data?.data?.find((item, index) => {
      return item?.event_id == eventId;
    });
  const [event_link, setEvent_link] = useState(``);
  useEffect(() => {
    const eventRoute = filteredEvent?.event_link;
    setEvent_link(eventRoute);
  }, [filteredEvent]);

  // dynamically wrap the styles
  useEffect(() => {
    if (event_link) {
      const styleId = `dynamic-style-${event_link}`;

      // Remove existing style if already present
      const existingStyle = document.getElementById(styleId);
      if (existingStyle) {
        existingStyle.remove();
      }

      // Fetch CSS content from server
      fetch(`${process.env.REACT_APP_BACKEND_URL}/events/css/style-${event_link}.css`)
        .then((response) => response.text())
        .then((css) => {
          const style = document.createElement("style");
          style.id = styleId;
          style.innerHTML = css;
          document.head.appendChild(style);
        })
        .catch((error) => console.error("Error loading styles:", error));

      return () => {
        const removeStyle = document.getElementById(styleId);
        if (removeStyle) {
          removeStyle.remove();
        }
      };
    }
  }, [event_link]);


  useEffect(() => {
    const url = new URL(window.location.href);
    const segments = url.pathname.split("/");
    const pathSegments = segments[segments.indexOf("events") + 1];
    sessionStorage.setItem("isAtAllEvents", false);
    setIsAtAllEvents(sessionStorage.getItem("isAtAllEvents"));

    if (pathSegments) {
      const eventName = pathSegments;
      setEventName(eventName);
      storeEventName(eventName);
      sessionStorage.setItem("eventName", eventName);
    } else {
      console.error("No valid segments found in the URL");
    }
  }, []);

  useEffect(() => {
    if (offerImages?.data && !offerLoading && !offerError) {
      dispatch(crOffer(offerImages.data));
    }
  }, [offerImages, offerLoading, offerError, dispatch]);

  return (
    <>
      {eventName && (
        <div>
          <ToastContainer autoClose={2000} />
          <Navbar isAtAllEvents={false} className="sticky-navbar" eventName={eventName} />
          <div
            className="overflow-hidden landing-container"
            style={{
              backgroundColor: backgroundColor || "white",
              paddingTop: "20vh",
            }}
          >
            <OfferCarousel eventName={eventName} />
            <CategoryOffer
              offerImages={offerImages}
              isTablet={isTablet}
              isMobile={isMobile}
              isLoading={offerLoading}
              isError={offerError}
              eventName={eventName}
            />
            <Ads eventName={eventName} />
            <Event eventName={eventName} />
            <FeaturedCategories eventName={eventName} />
            <PopularProducts eventName={eventName} />
            <Combo eventName={eventName} />
            <TrendingProducts eventName={eventName} />
            <div id="how-it-works-section">
              <Howitworks eventName={eventName} sx={{
                fontSize: fontSize,
                fontFamily: fontFamily,
                fontWeight: fontWeight,
                fontFamilyHeading: fontFamilyHeading,
                fontWeightHeading: fontWeightHeading,
                fontSizeHeading: fontSizeHeading,
                textColor: textColor,

              }}/>
            </div>
            <div id="faq-section">
              <Faq eventName={eventName} />
            </div>
            <AppSuggestion eventName={eventName} />
            <Footer eventName={eventName} />
          </div>
        </div>
      )}
    </>
  );
};

export default Landing;
